import * as React from 'react';
import Typography from '@mui/material/Typography';

export const InputHelper = (props: InputHelperProps) => {
    const { text, ...rest } = props;

    return  (
        <Typography 
            component="span" 
            sx={{ 
                fontSize: "12px", 
                fontStyle: "italic", 
                fontWeight: 600,
                color: "#65748B",
            }} 
            dangerouslySetInnerHTML={{ __html: text }} 
            {...rest}
        />
    );
};

export interface InputHelperProps {
    text: string;
}
